
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { SCENARIO_ANALYSIS } from '../../utils/chart-options';
import Highcharts from "highcharts";
import { HighchartsChartModule } from 'highcharts-angular';
import { ButtonComponent } from "@mds/ui";
import { EmptyChartComponent } from "@pages/dashboards/shared/empty-chart/empty-chart.component";

@Component({
  selector: 'app-scores-compare',
  templateUrl: './score-compare.component.html',
  styleUrls: ['./score-compare.component.scss'],
  standalone: true,
  imports: [MatCardModule, MdsIconsModule, HighchartsChartModule, ButtonComponent, EmptyChartComponent]
})
export class ScoreCompareComponent implements OnInit {
  protected readonly Highcharts = Highcharts;
  icons = MdsIcon;
  chartOptions: Highcharts.Options;
  chartColorCodes = ['#00747A', '#219491', '#01C9B3', '#BFF1EC'];
  xAxisData = [];
  emptyChart = { title: "No Data", description: "No data available." };
  @Input() data: any;
  @Output() configureAlternatives = new EventEmitter<boolean>();
  seriesArrayData: any = []

  ngOnInit(): void {
    this.setChartData(this.data)
  }

  setChartData(data: any) {
    if (!this.data) {
      return;
    }
    const series = this.seriesData(data);
    this.chartOptions = {
      ...SCENARIO_ANALYSIS,
      series,
      xAxis: {
        categories: this.xAxisData,
        crosshair: true,
        labels: {
          rotation: -45, // or 45, depending on direction
          style: {
            fontSize: '12px', // optional: adjust size for clarity
          }
        },
        accessibility: {
          description: ''
        }
      }
    };
  }

  seriesData(data: any) {
    this.xAxisData = [];
    if (data.lines) {
      data.lines.forEach((ele: any) => {
        this.xAxisData.push(ele.name)
        if (this.seriesArrayData.length < 1) {
          ele.impacts.forEach((val, index) => {
            this.seriesArrayData.push(
              {
                name: val.category,
                data: [parseFloat(val.impact)],
                color: this.chartColorCodes[index % this.chartColorCodes.length]
              }
            )
          });
        } else {
          ele.impacts.forEach((val, index) => {
            let isMatched = false;
            this.seriesArrayData.forEach((seriesArray) => {
              if (seriesArray.name == val.category) {
                seriesArray.data.push(parseFloat(val.impact));
                isMatched = true;
              }
            });
            if (!isMatched) {
              this.seriesArrayData.push(
                {
                  name: val.category,
                  data: [parseFloat(val.impact)],
                  color: this.chartColorCodes[index % this.chartColorCodes.length]
                }
              )
            }

          })
        }
      })
    }
    return this.seriesArrayData;
  }

  configureProductAlternatives() {
    this.configureAlternatives.emit(true)
  }

}
